export default class {
  constructor({
    id,
  }) {
    // Elements and class variables
    const el = document.getElementById(id);
    let intervalId = 0;

    function scrollStep() {
    	if (window.pageYOffset === 0) {
    		clearInterval(intervalId);
    	}
    	window.scroll(0, window.pageYOffset - 25);
    }

    function scrollToTop() {
    	intervalId = setInterval(scrollStep, 1);
    }

    function handleScroll(e) {
    	e.preventDefault();
    	scrollToTop();
    }

    el.addEventListener('click', handleScroll);
  }
}